const initialModelData = {
    "Climate Change": {
        "nodes": [
            {
                "id": "Human Change",
                "type": "model",
                "description": "Climate change is caused by humans who are releasing gases into the atmosphere."
            },
            {
                "id": "Solar Change",
                "type": "model",
                "description": "Climate change is caused by increasing amounts of energy released from the Sun."
            },
            {
                "id": "Evidence #1",
                "type": "evidence",
                "description": "Atmospheric greenhouse gas concentrations have been rising for the past 50 years. Human activities have led to greater releases of greenhouse gases. Temperatures have also been rising during these past 50 years.",
                "references": [
                    "https://cdn.serc.carleton.edu/files/mel/teaching_resources/climate_change_mel_ndash_15281434381744143177.v3.pdf",
                    "https://www.epa.gov/climate-indicators/climate-change-indicators-atmospheric-concentrations-greenhouse-gases",
                    "https://ourworldindata.org/climate-change"
                ]
            },
            {
                "id": "Evidence #2",
                "type": "evidence",
                "description": "Solar activity has decreased since 1970. Lower activity means that Earth has received less of the Sun's energy. But, Earth's temperature has continued to rise.",
                "references": [
                    "https://cdn.serc.carleton.edu/files/mel/teaching_resources/climate_change_mel_ndash_15281434381744143177.v3.pdf",
                    "https://science.nasa.gov/earth/climate-change/what-is-the-suns-role-in-climate-change/"
                ]
            },
            {
                "id": "Evidence #3",
                "type": "evidence",
                "description": "Satellites are measuring more of Earth's energy being absorbed by greenhouse gases.",
                "references": [
                    "https://cdn.serc.carleton.edu/files/mel/teaching_resources/climate_change_mel_ndash_15281434381744143177.v3.pdf",
                    "https://earthobservatory.nasa.gov/blogs/earthmatters/2021/06/22/earths-radiation-budget-is-out-of-balance/"
                ]
            },
            {
                "id": "Evidence #4",
                "type": "evidence",
                "description": "Increases and decreases in global temperatures closely matched increases and decreases in solar activity before the industrial revolution.",
                "references": [
                    "https://cdn.serc.carleton.edu/files/mel/teaching_resources/climate_change_mel_ndash_15281434381744143177.v3.pdf",
                    "https://www.sciencedirect.com/science/article/abs/pii/S1364682698001138"
                ]
            }
        ],
        "links": [
            {
                "source": "Evidence #1",
                "target": "Human Change",
                "value": 2
            },
            {
                "source": "Evidence #2",
                "target": "Human Change",
                "value": 1
            },
            {
                "source": "Evidence #2",
                "target": "Solar Change",
                "value": -2
            },
            {
                "source": "Evidence #3",
                "target": "Human Change",
                "value": 2
            },
            {
                "source": "Evidence #4",
                "target": "Solar Change",
                "value": 1
            }
        ]
    },
    "Extreme Weather": {
        nodes: [
            { id: 'Absorption', type: 'model', description: 'The number and strength of extreme weather events vary naturally. Human activities release carbon in the atmosphere. Yet, plants and oceans absorb any carbon increases.' },
            { id: 'Human Changes', type: 'model', description: 'Increases in extreme weather events are linked to climate change. Current climate change is mainly caused by human activities, such as fossil fuel use.' },
            { id: 'Solar Change', type: 'model', description: 'Over time, increases and decreases in extreme weather events are mainly caused by changes in Earth\'s orbit around the Sun.' },
            { id: 'Evidence #1', type: 'evidence', description: 'Since 1950, Earth\'s atmosphere and oceans have changed. The amount of carbon released to the atmosphere has risen. Dissolved carbon in the ocean has also risen. More carbon has increased ocean acidity and coral bleaching.' },
            { id: 'Evidence #2', type: 'evidence', description: 'From 1910 to 1995, record rainfall events increased across the United States. Over the same time period, there was a sharp increase in the amount of carbon released to the air. Much of this carbon comes from fossil fuel use.' },
            { id: 'Evidence #3', type: 'evidence', description: 'Ocean sea surface temperatures have increased since about 1970. In the North Atlantic, tropical storm power has also increased over this same time period. A storm\'s power depends on its strength and how long it lasts.' },
            { id: 'Evidence #4', type: 'evidence', description: 'Since 2000, there have been more intense, extreme, weather events around the world. Record rainfall fell in Europe. The southeastern United States had the most active month of tornadoes. The decade from 2000 to 2010 was the warmest ever during the past 1000 years.' },
            { id: 'Evidence #5', type: 'evidence', description: 'Frequency and size of large wildfires have increased in the Western U.S. since 1970. Average spring and summer temperatures have also risen in the Western U.S. during this time.' },
            { id: 'Evidence #6', type: 'evidence', description: 'In the last 100 years, global temperatures have increased. In that same time period, heavy precipitation events have also increased.' },
            { id: 'Evidence #7', type: 'evidence', description: 'Arctic Ocean sea ice extent has declined, with the Arctic warming at a pace two to three times the planet\'s average. Over the last decade, record cold temperatures and snowfall have occurred in Europe and Asia.' },
            { id: 'Evidence #8', type: 'evidence', description: 'Earth\'s orbit is elliptical. But, the shape of the ellipse is almost a perfect circle. In the Northern Hemisphere, Earth is slightly closer to the Sun in winter than in summer.' },
        ],
        links: [
            { source: 'Evidence #1', target: 'Human Changes', value: 2 },
            { source: 'Evidence #1', target: 'Absorption', value: -2 },
            { source: 'Evidence #2', target: 'Human Changes', value: 2 },
            { source: 'Evidence #3', target: 'Human Changes', value: 1 },
            { source: 'Evidence #4', target: 'Human Changes', value: 2 },
            { source: 'Evidence #5', target: 'Human Changes', value: 2 },
            { source: 'Evidence #6', target: 'Human Changes', value: 2 },
            { source: 'Evidence #7', target: 'Human Changes', value: 1 },
            { source: 'Evidence #7', target: 'Solar Change', value: 1 },
            { source: 'Evidence #8', target: 'Solar Change', value: 1 },
        ],
    },
    "Fracking and Earthquakes": {
        nodes: [
            { id: 'Fracking', type: 'model', description: 'The increase in moderate magnitude earthquakes in the Midwest is caused by fracking for fossil fuels.' },
            { id: 'Tectonics', type: 'model', description: 'The increase in moderate magnitude earthquakes in the Midwest is caused by normal tectonic plate motion.' },
            { id: 'Evidence #1', type: 'evidence', description: 'Fracking fluids and wastewater injected into the ground change the stress in Earth\'s crust.' },
            { id: 'Evidence #2', type: 'evidence', description: 'During recent years, the number of earthquakes near fracking sites was 11 times higher than the 30-year average.' },
            { id: 'Evidence #3', type: 'evidence', description: 'Convection of hot but solid and ductile rocks in the upper mantle creates stresses in Earth\'s crust. These stresses cause Earth\'s crust to fracture.' },
            { id: 'Evidence #4', type: 'evidence', description: 'Many earthquakes are currently occurring in regions surrounding fracking sites.' },
        ],
        links: [
            { source: 'Evidence #1', target: 'Fracking', value: 2 },
            { source: 'Evidence #2', target: 'Fracking', value: 2 },
            { source: 'Evidence #3', target: 'Tectonics', value: 2 },
            { source: 'Evidence #4', target: 'Fracking', value: 1 },
            { source: 'Evidence #4', target: 'Tectonics', value: 1 },
        ],
    },
    "Nuclear Energy": {
        "nodes": [
            {
                "id": "Safe and Reliable",
                "type": "model",
                "description": "Nuclear energy is a safe and efficient way to make power. It can meet human energy needs and protect the environment when used safely.",
                "references": [
                    "https://www.energy.gov/ne/articles/nuclear-power-most-reliable-energy-source-and-its-not-even-close"
                ]
            },
            {
                "id": "Too Risky",
                "type": "model",
                "description": "Nuclear energy has safety risks and environmental problems. Accidents and waste make it too dangerous to use.",
                "references": [
                    "https://www.ucsusa.org/nuclear-power/nuclear-power-accidents/history-nuclear-accidents"
                ]
            },
            {
                "id": "1 - Chernobyl/Fukashima",
                "type": "evidence",
                "description": "Big nuclear power plant accidents, like Chernobyl and Fukushima, resulted in environmental damage and long-term health problems for many people.",
                "references": [
                    "https://www.cancer.gov/about-cancer/causes-prevention/risk/radiation/nuclear-accidents-fact-sheet",
                    "https://www.livescience.com/65554-chernobyl-vs-fukushima.html"
                ]
            },
            {
                "id": "2 - Less CO2",
                "type": "evidence",
                "description": "Nuclear power plants produce much less carbon dioxide during operation compared to coal or gas plants.",
                "references": [
                    "https://www.eia.gov/energyexplained/nuclear/nuclear-power-and-the-environment.php ",
                    "https://earth.org/nuclear-energy-carbon-emissions-lowest-among-electricity-sources-un-reports/",
                    "https://world-nuclear.org/nuclear-essentials/how-can-nuclear-combat-climate-change"
                ]
            },
            {
                "id": "3 - Waste Storage",
                "type": "evidence",
                "description": "The storage and disposal of radioactive waste from nuclear power plants remain challenging, with some waste remaining hazardous for thousands of years.",
                "references": [
                    "https://sustainability.stanford.edu/news/steep-costs-nuclear-waste-us",
                    "https://earth.org/nuclear-waste-disposal/"
                ]
            },
            {
                "id": "4 - Reliable Power",
                "type": "evidence",
                "description": "Nuclear power plants can operate continuously for long periods, providing a stable baseload power supply independent of weather conditions.",
                "references": [
                    "https://www.nei.org/news/2024/for-reliability-look-no-further-than-nuclear",
                    "https://www.energy.gov/ne/articles/nuclear-power-most-reliable-energy-source-and-its-not-even-clos"
                ]
            },
            {
                "id": "5 - Reactor Safety",
                "type": "evidence",
                "description": "Modern nuclear reactors have multiple safety systems and containment structures to prevent accidents and contain radiation in case of emergencies.",
                "references": [
                    "https://www.energy.gov/ne/enhanced-safety-advanced-reactors",
                    "https://www.gisreportsonline.com/r/nuclear-energy-safe",
                    "https://www.energyencyclopedia.com/en/nuclear-energy/the-safety-of-nuclear-power-plants/safety-systems"
                ]
            },
            {
                "id": "6 - Mining Risks",
                "type": "evidence",
                "description": "The mining and processing of uranium for nuclear fuel can have negative environmental impacts and poses health risks to workers and nearby communities.",
                "references": [
                    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3653646",
                    "https://www.fairewinds.org/uranium-mining",
                    "http://large.stanford.edu/courses/2017/ph241/longstaff1"
                ]
            },
            {
                "id": "7 - Thermal Pollution",
                "type": "evidence",
                "description": "Thermal pollution from nuclear plants affects nearby water ecosystems, as heated water discharged into rivers or lakes can disrupt aquatic life. However, traditional fossil fuel plants are also producers of thermal pollution.",
                "references": [
                    "https://world-nuclear.org/information-library/current-and-future-generation/cooling-power-plants ",
                    "http://large.stanford.edu/courses/2019/ph241/clark1",
                    "https://www.perchenergy.com/blog/environment/what-is-thermal-pollution-causes-impact"
                ]
            },
            {
                "id": "8 - Energy Independence",
                "type": "evidence",
                "description": "Countries with large nuclear power programs, such as France, generate a significant percentage of their electricity from nuclear energy, demonstrating its potential to reduce dependency on fossil fuels and become energy independent.",
                "references": [
                    "https://www.iaea.org/newscenter/news/frances-efficiency-in-the-nuclear-fuel-cycle-what-can-oui-learn",
                    "https://emag.vinci.com/en/france-land-nuclear-power",
                    "https://electricityforum.com/news/france-demonstrates-role-of-nuclear-power"
                ]
            }
        ],
        "links": [
            {
                "source": "1 - Chernobyl/Fukashima",
                "target": "Too Risky",
                "value": 2
            },
            {
                "source": "2 - Less CO2",
                "target": "Safe and Reliable",
                "value": 2
            },
            {
                "source": "3 - Waste Storage",
                "target": "Too Risky",
                "value": 2
            },
            {
                "source": "4 - Reliable Power",
                "target": "Safe and Reliable",
                "value": 2
            },
            {
                "source": "5 - Reactor Safety",
                "target": "Safe and Reliable",
                "value": 2
            },
            {
                "source": "5 - Reactor Safety",
                "target": "Too Risky",
                "value": -2
            },
            {
                "source": "6 - Mining Risks",
                "target": "Too Risky",
                "value": 1
            },
            {
                "source": "7 - Thermal Pollution",
                "target": "Too Risky",
                "value": 1
            },
            {
                "source": "8 - Energy Independence",
                "target": "Safe and Reliable",
                "value": 2
            }
        ]
    },
    "The Wetlands": {
        "nodes": [
            {
                "id": "Wetlands Valuable",
                "type": "model",
                "description": "Wetlands provide ecosystem services that contribute to human welfare and help sustain the biosphere.",
                "references": [
                    "https://www.epa.gov/wetlands"
                ],
                "display": {
                    "title": "Wetlands Valuable",
                    "description": "Wetlands provide ecosystem services that contribute to human welfare and help sustain the biosphere."
                }
            },
            {
                "id": "Wetlands Nuisance",
                "type": "model",
                "description": "Wetlands are a nuisance to humans and provide little overall environmental benefit.",
                "references": [
                    "https://www.epa.gov/wetlands/wetlands-regulations"
                ],
                "display": {
                    "title": "Wetlands Nuisance",
                    "description": "Wetlands are a nuisance to humans and provide little overall environmental benefit."
                }
            },
            {
                "id": "Evidence #1",
                "type": "evidence",
                "description": "Wetlands play a role in the global cycles of carbon, nitrogen, and sulfur. Wetlands change these nutrients into different forms necessary to continue their global cycles.",
                "references": [
                    "https://www.usgs.gov/centers/wetland-and-aquatic-research-center"
                ],
                "display": {
                    "title": "Evidence #1",
                    "description": "Wetlands play a role in the global cycles of carbon, nitrogen, and sulfur. Wetlands change these nutrients into different forms necessary to continue their global cycles."
                }
            },
            {
                "id": "Evidence #2",
                "type": "evidence",
                "description": "Flooding is a natural occurrence in low-lying areas and wetlands are places where floodwaters can collect.",
                "references": [
                    "https://www.fws.gov/sites/default/files/documents/2024-04/wetlands-status-and-trends-report-2009-to-2019_0.pdf",
                    "https://oceanservice.noaa.gov/facts/wetland.html"
                ],
                "display": {
                    "title": "Evidence #2",
                    "description": "Flooding is a natural occurrence in low-lying areas and wetlands are places where floodwaters can collect."
                }
            },
            {
                "id": "Evidence #3",
                "type": "evidence",
                "description": "Wetlands contribute 70 percent of global atmospheric methane from natural sources.",
                "references": [
                    "https://www.metoffice.gov.uk/research/approach/collaboration/wcssp/insights/brazil_methane",
                    "https://www.beefmagazine.com/cattle-market-outlook/is-climate-science-really-real-depends-on-who-s-behind-it"
                ],
                "display": {
                    "title": "Evidence #3",
                    "description": "Wetlands contribute 70 percent of global atmospheric methane from natural sources."
                }
            },
            {
                "id": "Evidence #4",
                "type": "evidence",
                "description": "Many wetlands are located in rapidly developing areas of the country.",
                "references": [
                    "https://www.fws.gov/sites/default/files/documents/2024-04/wetlands-status-and-trends-report-2009-to-2019_0.pdf",
                    "https://www.fws.gov/program/national-wetlands-inventory/wetlands-mapper"
                ],
                "display": {
                    "title": "Evidence #4",
                    "description": "Many wetlands are located in rapidly developing areas of the country."
                }
            }
        ],
            "links": [
            {
                "source": "Evidence #2",
                "target": "Wetlands Valuable",
                "value": 2
            },
            {
                "source": "Evidence #3",
                "target": "Wetlands Nuisance",
                "value": 1
            },
            {
                "source": "Evidence #3",
                "target": "Wetlands Valuable",
                "value": -2
            },
            {
                "source": "Evidence #1",
                "target": "Wetlands Valuable",
                "value": 2
            },
            {
                "source": "Evidence #1",
                "target": "Wetlands Nuisance",
                "value": -2
            },
            {
                "source": "Evidence #2",
                "target": "Wetlands Nuisance",
                "value": -2
            },
            {
                "source": "Evidence #4",
                "target": "Wetlands Nuisance",
                "value": 1
            }
        ]
    },
    "Moon Formation": {
        "nodes": [
            {
                "id": "Captured Moon",
                "type": "model",
                "description": "The Moon was an object that came from elsewhere in the solar system and was captured by Earth's gravity.",
                "references": [],
                "display": {
                    "title": "Captured Moon",
                    "description": "The Moon was an object that came from elsewhere in the solar system and was captured by Earth's gravity."
                }
            },
            {
                "id": "Collision Moon",
                "type": "model",
                "description": "The Moon formed after a large object collided with Earth and material from both combined to create the moon.",
                "references": [],
                "display": {
                    "title": "Collision Moon",
                    "description": "The Moon formed after a large object collided with Earth and material from both combined to create the moon."
                }
            },
            {
                "id": "Evidence #1",
                "type": "evidence",
                "description": "Earth's average density is higher than the Moon's. The density of Earth's crust is a little lower than the Moon's, but Earth's density increases toward the core.",
                "references": [
                    "https://www.theodysseyonline.com/5-moon-facts"
                ],
                "display": {
                    "title": "Evidence #1",
                    "description": "Earth's average density is higher than the Moon's. The density of Earth's crust is a little lower than the Moon's, but Earth's density increases toward the core."
                }
            },
            {
                "id": "Evidence #2",
                "type": "evidence",
                "description": "Simulations of other star systems show that planets form when smaller objects collide.",
                "references": [
                    "https://www.nhm.ac.uk/discover/how-did-the-moon-form.html#:~:text=The%20giant%2Dimpact%20theory%20is,Earth%20to%20form%20the%20Moon",
                    "https://science.nasa.gov/moon/formation/"
                ],
                "display": {
                    "title": "Evidence #2",
                    "description": "Simulations of other star systems show that planets form when smaller objects collide."
                }
            },
            {
                "id": "Evidence #3",
                "type": "evidence",
                "description": "The Moon's orbit around Earth is tilted compared to the planets' orbits around the Sun.",
                "references": [
                    "https://www.space.com/dirty-collisions-planet-formation.html"
                ],
                "display": {
                    "title": "Evidence #3",
                    "description": "The Moon's orbit around Earth is tilted compared to the planets' orbits around the Sun."
                }
            },
            {
                "id": "Evidence #4",
                "type": "evidence",
                "description": "Earth is about 35% iron, most of which is in the core. The Moon has very little iron.",
                "references": [
                    "https://ares.jsc.nasa.gov/astromaterials3d/index.htm"
                ],
                "display": {
                    "title": "Evidence #4",
                    "description": "Earth is about 35% iron, most of which is in the core. The Moon has very little iron."
                }
            }
        ],
        "links": [
            {
                "source": "Evidence #1",
                "target": "Collision Moon",
                "value": 1
            },
            {
                "source": "Evidence #2",
                "target": "Collision Moon",
                "value": 2
            },
            {
                "source": "Evidence #3",
                "target": "Collision Moon",
                "value": 1
            },
            {
                "source": "Evidence #4",
                "target": "Captured Moon",
                "value": 1
            },
            {
                "source": "Evidence #4",
                "target": "Collision Moon",
                "value": 1
            }
        ]
    },
    "Honeybee Decline": {
        nodes: [
            { id: 'Pesticides', type: 'model', description: 'The widespread use of neonicotinoid pesticides is the primary cause of honeybee colony collapse.' },
            { id: 'Parasites', type: 'model', description: 'Parasites, particularly the Varroa destructor mite, are the main factor in honeybee colony decline.' },
            { id: 'Habitat Loss', type: 'model', description: 'Loss of natural habitats and reduced biodiversity due to industrial agriculture are driving honeybee colony collapse.' },
            { id: 'Climate Change', type: 'model', description: 'Climate change-induced weather patterns and seasonal shifts are disrupting honeybee life cycles and causing colony collapse.' },
            { id: 'Evidence #1', type: 'evidence', description: 'Studies show that exposure to neonicotinoid pesticides impairs honeybees\' navigation abilities and reduces colony growth.',
                references: ['https://doi.org/10.1126/science.1215025'] },
            { id: 'Evidence #2', type: 'evidence', description: 'Varroa mites have been found to transmit deformed wing virus, which is highly prevalent in collapsed colonies.',
                references: ['https://doi.org/10.1371/journal.ppat.1004323'] },
            { id: 'Evidence #3', type: 'evidence', description: 'Areas with greater crop diversity and natural habitats show higher honeybee colony survival rates.',
                references: ['https://doi.org/10.1126/science.1232728'] },
            { id: 'Evidence #4', type: 'evidence', description: 'Shifting bloom times due to climate change are causing mismatches between honeybee activity and flower availability.',
                references: ['https://doi.org/10.1111/gcb.13141'] },
            { id: 'Evidence #5', type: 'evidence', description: 'Honeybee colonies in areas with high neonicotinoid use show higher winter losses compared to low-use areas.',
                references: ['https://doi.org/10.1126/science.1255957'] },
            { id: 'Evidence #6', type: 'evidence', description: 'Varroa mite infestations weaken honeybees\' immune systems, making them more susceptible to viral infections.',
                references: ['https://doi.org/10.1371/journal.ppat.1004816'] },
            { id: 'Evidence #7', type: 'evidence', description: 'Monoculture farming practices reduce the diversity of pollen sources, leading to nutritional stress in honeybees.',
                references: ['https://doi.org/10.1371/journal.pone.0103592'] },
            { id: 'Evidence #8', type: 'evidence', description: 'Extreme weather events, such as droughts and heat waves, are associated with increased colony losses.',
                references: ['https://doi.org/10.1007/s13592-016-0441-y'] },
            { id: 'Evidence #9', type: 'evidence', description: 'Sub-lethal doses of neonicotinoids affect honeybees\' learning and memory, impairing foraging efficiency.',
                references: ['https://doi.org/10.1038/nature11585'] },
            { id: 'Evidence #10', type: 'evidence', description: 'The global spread of Varroa mites correlates with increased honeybee colony losses in affected regions.',
                references: ['https://doi.org/10.1146/annurev-ento-011613-162005'] },
            { id: 'Evidence #11', type: 'evidence', description: 'Urban development and agricultural intensification have reduced the availability of suitable nesting sites for honeybees.',
                references: ['https://doi.org/10.1016/j.agee.2015.09.027'] },
            { id: 'Evidence #12', type: 'evidence', description: 'Climate change has altered the geographic distribution of plant species, affecting honeybee foraging patterns.',
                references: ['https://doi.org/10.1111/gcb.14008'] },
            { id: 'Evidence #13', type: 'evidence', description: 'Countries that have banned neonicotinoid pesticides have observed improvements in honeybee population health.',
                references: ['https://doi.org/10.1126/science.aau5962'] },
            { id: 'Evidence #14', type: 'evidence', description: 'Genetic diversity in honeybee populations is negatively correlated with Varroa mite infestation levels.',
                references: ['https://doi.org/10.1038/s41559-019-0826-1'] },
            { id: 'Evidence #15', type: 'evidence', description: 'The conversion of natural landscapes to agricultural land has reduced the abundance and diversity of wild flowers.',
                references: ['https://doi.org/10.1016/j.tree.2010.01.007'] },
            { id: 'Evidence #16', type: 'evidence', description: 'Warmer winters due to climate change disrupt honeybee hibernation patterns, leading to increased energy consumption.',
                references: ['https://doi.org/10.1007/s10584-017-1973-5'] },
            { id: 'Evidence #17', type: 'evidence', description: 'Exposure to multiple pesticides has synergistic negative effects on honeybee health, beyond the impact of individual chemicals.',
                references: ['https://doi.org/10.1038/nature20588'] },
            { id: 'Evidence #18', type: 'evidence', description: 'Varroa mites have developed resistance to common treatment methods, making infestations increasingly difficult to control.',
                references: ['https://doi.org/10.1371/journal.pone.0155332'] },
            { id: 'Evidence #19', type: 'evidence', description: 'Increased monoculture farming has led to seasonal gaps in nectar availability, stressing honeybee colonies.',
                references: ['https://doi.org/10.1016/j.agee.2014.09.022'] },
            { id: 'Evidence #20', type: 'evidence', description: 'Climate change-induced shifts in precipitation patterns affect the quality and quantity of nectar produced by plants.',
                references: ['https://doi.org/10.1111/gcb.13454'] },
        ],
        links: [
            { source: 'Evidence #1', target: 'Pesticides', value: 2 },
            { source: 'Evidence #2', target: 'Parasites', value: 2 },
            { source: 'Evidence #3', target: 'Habitat Loss', value: 2 },
            { source: 'Evidence #4', target: 'Climate Change', value: 2 },
            { source: 'Evidence #5', target: 'Pesticides', value: 2 },
            { source: 'Evidence #6', target: 'Parasites', value: 2 },
            { source: 'Evidence #7', target: 'Habitat Loss', value: 2 },
            { source: 'Evidence #8', target: 'Climate Change', value: 2 },
            { source: 'Evidence #9', target: 'Pesticides', value: 2 },
            { source: 'Evidence #10', target: 'Parasites', value: 2 },
            { source: 'Evidence #11', target: 'Habitat Loss', value: 2 },
            { source: 'Evidence #12', target: 'Climate Change', value: 2 },
            { source: 'Evidence #13', target: 'Pesticides', value: 2 },
            { source: 'Evidence #14', target: 'Parasites', value: 2 },
            { source: 'Evidence #15', target: 'Habitat Loss', value: 2 },
            { source: 'Evidence #16', target: 'Climate Change', value: 2 },
            { source: 'Evidence #17', target: 'Pesticides', value: 2 },
            { source: 'Evidence #18', target: 'Parasites', value: 2 },
            { source: 'Evidence #19', target: 'Habitat Loss', value: 2 },
            { source: 'Evidence #20', target: 'Climate Change', value: 2 },
            { source: 'Evidence #3', target: 'Climate Change', value: 1 },
            { source: 'Evidence #7', target: 'Pesticides', value: 1 },
            { source: 'Evidence #11', target: 'Climate Change', value: 1 },
            { source: 'Evidence #15', target: 'Pesticides', value: 1 },
            { source: 'Evidence #19', target: 'Climate Change', value: 1 },
        ],
    },
    "Climate Change vs Geoengineering": {
        "nodes": [
            {
                "id": "Climate Change",
                "description": "Increased intensity of recent hurricanes is the result of anthropogenic climate change",
                "type": "model"
            },
            {
                "id": "Geo engineering",
                "description": "Increased intensity of recent hurricanes is the result of government geoengineering",
                "type": "model"
            },
            {
                "id": "NOAA Study",
                "description": "A NOAA study shows that hurricane intensity has increased by 8% per decade since the 1980s, correlating with rising global temperatures.",
                "type": "evidence",
                "references": [
                    "https://www.gfdl.noaa.gov/global-warming-and-hurricanes/"
                ]
            },
            {
                "id": "Warmer Oceans",
                "description": "Satellite data reveals that ocean surface temperatures in hurricane-prone regions have increased by 0.5°C since 1980.",
                "type": "evidence",
                "references": [
                    "https://www.climate.gov/news-features/blogs/beyond-data/can-we-detect-change-atlantic-hurricanes-today-due-human-caused"
                ]
            },
            {
                "id": "Hurricane Modeling",
                "description": "Climate models predict that warmer oceans will lead to more intense hurricanes, matching observed trends.",
                "type": "evidence",
                "references": [
                    "https://www.nature.com/articles/s41558-020-0851-8"
                ]
            },
            {
                "id": "Historical Records",
                "description": "Analysis of historical records shows no significant increase in hurricane frequency, but an increase in the proportion of high-intensity storms.",
                "type": "evidence",
                "references": [
                    "https://www.gfdl.noaa.gov/historical-atlantic-hurricane-and-tropical-storm-records/"
                ]
            },
            {
                "id": "Rapid Intensification",
                "description": "Recent hurricanes have shown more frequent rapid intensification, a phenomenon consistent with climate change predictions.",
                "type": "evidence",
                "references": [
                    "https://agupubs.onlinelibrary.wiley.com/doi/full/10.1029/2018GL081589"
                ]
            },
        ],
        "links": [
            {"source": "NOAA Study", "target": "Climate Change", "value": 2},
            {"source": "Warmer Oceans", "target": "Climate Change", "value": 2},
            {"source": "Hurricane Modeling", "target": "Climate Change", "value": 2},
            {"source": "Historical Records", "target": "Climate Change", "value": 1},
            {"source": "Rapid Intensification", "target": "Climate Change", "value": 1},
            {"source": "NOAA Study", "target": "Geo engineering", "value": -2},
            {"source": "Hurricane Modeling", "target": "Geo engineering", "value": -2}
        ]
    },
    "Freshwater Resources": {
        "nodes": [
            {
                "id": "Abundant",
                "type": "model",
                "description": "Earth's freshwater is abundant and will remain so even in the face of global climate change.",
                "plausibility": -10
            },
            {
                "id": "Engineering Solutions",
                "type": "model",
                "description": "Earth's freshwater challenges will be solved by engineering solutions.",
                "plausibility": 1
            },
            {
                "id": "Shortage",
                "type": "model",
                "description": "Earth has a shortage of freshwater, which will worsen as our world's population increases.",
                "plausibility": 8
            },
            {
                "id": "Land Use Changes",
                "type": "evidence",
                "description": "Land use changes have generated large pressures on freshwater resources. These changes are affecting both water quality and availability.",
                "references": [
                    "https://www.ipcc.ch/site/assets/uploads/2018/02/ar4-wg2-chapter3-1.pdf",
                    "https://www.worldwildlife.org/threats/water-scarcity"
                ]
            },
            {
                "id": "Population Growth",
                "type": "evidence",
                "description": "The world's population is increasing. This stresses the supply of freshwater.",
                "references": [
                    "https://www.un.org/en/global-issues/population",
                    "https://ourworldindata.org/grapher/renewable-water-resources-per-capita"
                ]
            },
            {
                "id": "Groundwater Depletion",
                "type": "evidence",
                "description": "Groundwater provides freshwater to many people around the world. In many places, people are using groundwater faster than it is replaced by precipitation.",
                "references": [
                    "https://www.usgs.gov/special-topics/water-science-school/science/groundwater-decline-and-depletion"
                ]
            },
            {
                "id": "Treatment Costs",
                "type": "evidence",
                "description": "Water reclamation and desalination are expensive. The costs vary depending on location.",
                "references": [
                    "https://www.iwa-network.org/desalination-past-present-future/"
                ]
            },
            {
                "id": "Engineering Advances",
                "type": "evidence",
                "description": "Advances in engineering have led to better access to quality drinking water. At the same time life expectancy and quality of life have improved.",
                "references": [
                    "https://www.who.int/news-room/fact-sheets/detail/drinking-water",
                    "https://www.cdc.gov/global-water-sanitation-hygiene/about/?CDC_AAref_Val=https://www.cdc.gov/healthywater/global/index.html"
                ]
            },
            {
                "id": "Glacial Retreat",
                "type": "evidence",
                "description": "Glaciers are a source of freshwater in many parts of the world. Glacial ice mass is decreasing worldwide.",
                "references": [
                    "https://nsidc.org/cryosphere/glaciers/questions/climate.html"
                ]
            },
            {
                "id": "Microclimate Models",
                "type": "evidence",
                "description": "Microclimates are climates of very small areas that usually differ from the surrounding areas. Scientists are developing high-resolution models to accurately predict microclimate trends in freshwater availability.",
                "references": [
                    "https://onlinelibrary.wiley.com/doi/10.1111/geb.13834"
                ]
            },
            {
                "id": "US Climate Trends",
                "type": "evidence",
                "description": "In the contiguous US, average temperatures and precipitation have increased since 1901. From 2000-2015, the US was abnormally dry with some parts of the country in moderate to severe drought.",
                "references": [
                    "https://www.epa.gov/climate-indicators/weather-climate",
                    "https://www.drought.gov/historical-information"
                ]
            }
        ],
        "links": [
            {
                "source": "Land Use Changes",
                "target": "Abundant",
                "value": -2
            },
            {
                "source": "Land Use Changes",
                "target": "Shortage",
                "value": 2
            },
            {
                "source": "Population Growth",
                "target": "Abundant",
                "value": -2
            },
            {
                "source": "Population Growth",
                "target": "Shortage",
                "value": 2
            },
            {
                "source": "Groundwater Depletion",
                "target": "Abundant",
                "value": -2
            },
            {
                "source": "Groundwater Depletion",
                "target": "Shortage",
                "value": 2
            },
            {
                "source": "Treatment Costs",
                "target": "Engineering Solutions",
                "value": -2
            },
            {
                "source": "Engineering Advances",
                "target": "Engineering Solutions",
                "value": 2
            },
            {
                "source": "Engineering Advances",
                "target": "Shortage",
                "value": -2
            },
            {
                "source": "Glacial Retreat",
                "target": "Abundant",
                "value": -2
            },
            {
                "source": "Glacial Retreat",
                "target": "Shortage",
                "value": 2
            },
            {
                "source": "Microclimate Models",
                "target": "Engineering Solutions",
                "value": 1
            },
            {
                "source": "US Climate Trends",
                "target": "Abundant",
                "value": -2
            },
            {
                "source": "US Climate Trends",
                "target": "Shortage",
                "value": 2
            }
        ]
    },
    "Nutrient Use and Dead Zones": {
        "nodes": [
            {
                "id": "Model A",
                "type": "model",
                "description": "We should balance the use of nutrients in agriculture and communities. It is important to eliminate dead zones and the damage they cause.",
                "display": {
                    "title": "Model A",
                    "description": "We should balance the use of nutrients in agriculture and communities. It is important to eliminate dead zones and the damage they cause."
                },
                "plausibility": 5
            },
            {
                "id": "Model B",
                "type": "model",
                "description": "Agricultural science and engineering solutions can reduce the damage caused by nutrient use. This can reduce the impacts caused by dead zones.",
                "display": {
                    "title": "Model B",
                    "description": "Agricultural science and engineering solutions can reduce the damage caused by nutrient use. This can reduce the impacts caused by dead zones."
                },
                "plausibility": 3
            },
            {
                "id": "Model C",
                "type": "model",
                "description": "The use of nutrients that create dead zones can provide benefits that make up for the harm they cause.",
                "display": {
                    "title": "Model C",
                    "description": "The use of nutrients that create dead zones can provide benefits that make up for the harm they cause."
                },
                "plausibility": 1
            },
            {
                "id": "Evidence #1",
                "type": "evidence",
                "description": "Methods to maintain healthy nutrient levels in bodies of water do not always work. Water nutrient levels return to normal when human overuse of fertilizer stops.",
                "display": {
                    "title": "Evidence #1",
                    "description": "Methods to maintain healthy nutrient levels in bodies of water do not always work. Water nutrient levels return to normal when human overuse of fertilizer stops."
                }
            },
            {
                "id": "Evidence #2",
                "type": "evidence",
                "description": "Over the past 50 years, the number and the size of dead zones have increased. Over the same time, fertilizer use has also increased.",
                "display": {
                    "title": "Evidence #2",
                    "description": "Over the past 50 years, the number and the size of dead zones have increased. Over the same time, fertilizer use has also increased."
                }
            },
            {
                "id": "Evidence #3",
                "type": "evidence",
                "description": "Eutrophication can increase fish populations. More algae means more food for fish to grow and reproduce. Fish will die when oxygen in water goes down.",
                "display": {
                    "title": "Evidence #3",
                    "description": "Eutrophication can increase fish populations. More algae means more food for fish to grow and reproduce. Fish will die when oxygen in water goes down."
                }
            },
            {
                "id": "Evidence #4",
                "type": "evidence",
                "description": "Fertilization and soil tillage helps to grow healthy crops. Efficient farming practices can help avoid excess fertilization and runoff into bodies of water.",
                "display": {
                    "title": "Evidence #4",
                    "description": "Fertilization and soil tillage helps to grow healthy crops. Efficient farming practices can help avoid excess fertilization and runoff into bodies of water."
                }
            },
            {
                "id": "Evidence #5",
                "type": "evidence",
                "description": "Algae blooms change the amounts of dissolved carbon and oxygen, and other toxins, in seawater. These changes can harm marine organisms.",
                "display": {
                    "title": "Evidence #5",
                    "description": "Algae blooms change the amounts of dissolved carbon and oxygen, and other toxins, in seawater. These changes can harm marine organisms."
                }
            },
            {
                "id": "Evidence #6",
                "type": "evidence",
                "description": "Farming, forestry, and fishing practices can be part of a region's economy. The health of these practices can impact the economy in both positive and negative ways.",
                "display": {
                    "title": "Evidence #6",
                    "description": "Farming, forestry, and fishing practices can be part of a region's economy. The health of these practices can impact the economy in both positive and negative ways."
                }
            },
            {
                "id": "Evidence #7",
                "type": "evidence",
                "description": "Marine life needs dissolved oxygen in water to live. As oxygen levels decrease in water, fewer and fewer organisms can survive. Dead zones occur when levels of dissolved oxygen in the water fall below 2 milligrams per liter (mg/L).",
                "display": {
                    "title": "Evidence #7",
                    "description": "Marine life needs dissolved oxygen in water to live. As oxygen levels decrease in water, fewer and fewer organisms can survive. Dead zones occur when levels of dissolved oxygen in the water fall below 2 milligrams per liter (mg/L)."
                }
            },
            {
                "id": "Evidence #8",
                "type": "evidence",
                "description": "Not all dead zones are caused by farming. Urbanization and overfishing can also cause dead zones.",
                "display": {
                    "title": "Evidence #8",
                    "description": "Not all dead zones are caused by farming. Urbanization and overfishing can also cause dead zones."
                }
            }
        ],
        "links": [
            { "source": "Evidence #1", "target": "Model A", "value": 2 },
            { "source": "Evidence #1", "target": "Model B", "value": -2 },
            { "source": "Evidence #2", "target": "Model A", "value": 2 },
            { "source": "Evidence #3", "target": "Model C", "value": 1 },
            { "source": "Evidence #4", "target": "Model B", "value": 2 },
            { "source": "Evidence #5", "target": "Model A", "value": 2 },
            { "source": "Evidence #6", "target": "Model C", "value": 2 },
            { "source": "Evidence #7", "target": "Model A", "value": 2 },
            { "source": "Evidence #8", "target": "Model B", "value": 1 }
        ]
    }
};

export default initialModelData;